module.exports = __webpack_public_path__ + "static/media/bird_fly07.10f0cf86.gif";